import { useMemo } from 'react';
import GlobalContainer from '~/components/global_container';

export const useSelectColor = () => useMemo(
  () => (GlobalContainer.product() === 'retention' ? '#4286C6' : '#16B783'),
  [],
);
